export default __webpack_public_path__ + "static/jira-product-discovery_attribution_light-c6dcf052a5e0939f70d6c7354341d3dc.svg";